// extracted by mini-css-extract-plugin
export default {"r_l":"_380ea6e8de _8c34d8306c","t":"_12e30a38fb"};